const headers = {
  'Cache-Control': 'no-store',
};

export default headers;
